import React, { useEffect, useState } from "react";
import { RxCrossCircled } from "react-icons/rx";
import { MdDashboard } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowAltCircleDown, FaArrowAltCircleRight } from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";
import {
  selectIsSidebarOpen,
  toggleSidebar,
} from "../../features/Toggle/sidebarSlice";

const SidebarMobile = () => {
  const dispatch = useDispatch();
  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };
  const isSidebarOpen = useSelector(selectIsSidebarOpen);

  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false);
  const [dealerMenuOpen, setDealerMenuOpen] = useState(false);
  const [supplierMenuOpen, setSupplierMenuOpen] = useState(false);
  const [purchaseMenuOpen, setPurchaseMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [salesMenuOpen, setSalesMenuOpen] = useState(false);
  const [transactionMenuOpen, setTransactionMenuOpen] = useState(false);
  const [reportMenuOpen, setReportMenuOpen] = useState(false);
  const [ledgerMenuOpen, setLedgerMenuOpen] = useState(false);
  const [returnMenuOpen, setReturnMenuOpen] = useState(false);
  const [bankMenuOpen, setBankMenuOpen] = useState(false);
  const [challanMenuOpen, setChallanMenuOpen] = useState(false);
  const [quotationMenuOpen, setQuotationMenuOpen] = useState(false);

  const toggleCategoryMenu = () => {
    setCategoryMenuOpen(!categoryMenuOpen);
  };
  const toggleQuotationMenu = () => {
    setQuotationMenuOpen(!quotationMenuOpen);
  };
  const toggleDealerMenu = () => {
    setDealerMenuOpen(!dealerMenuOpen);
  };
  const toggleSupplierMenu = () => {
    setSupplierMenuOpen(!supplierMenuOpen);
  };
  const toggleChallanMenu = () => {
    setChallanMenuOpen(!challanMenuOpen);
  };
  const togglePurchaseMenu = () => {
    setPurchaseMenuOpen(!purchaseMenuOpen);
  };
  const toggleReturnMenu = () => {
    setReturnMenuOpen(!returnMenuOpen);
  };
  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
  };
  const toggleSalesMenu = () => {
    setSalesMenuOpen(!salesMenuOpen);
  };
  const toggleTransactionMenu = () => {
    setTransactionMenuOpen(!transactionMenuOpen);
  };
  const toggleReportMenu = () => {
    setReportMenuOpen(!reportMenuOpen);
  };
  const toggleLedgerMenu = () => {
    setLedgerMenuOpen(!ledgerMenuOpen);
  };
  const toggleBankMenu = () => {
    setBankMenuOpen(!bankMenuOpen);
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    navigate("/");
  };
  return (
    <div
      className={`bg-gray-200 h-full overflow-auto no-scrollbar fixed z-50 w-[60%] transition-transform duration-300 transform p-4 block md:hidden ${
        isSidebarOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <h1 className="flex items-center gap-x-2 mt-4">
        <MdDashboard /> <span>Sony & Joy Telecom</span>
      </h1>

      <ul className="py-4 flex flex-col gap-2">
        <button
          className="absolute text-red-500 text-2xl right-2 top-2 block lg:hidden"
          onClick={handleToggleSidebar}
        >
          <RxCrossCircled />
        </button>
        {user?.role === "admin" && (
          <li>
            <a
              onClick={toggleUserMenu}
              href="#"
              className="flex items-center justify-between"
            >
              User Management
              {userMenuOpen === false && <FaArrowAltCircleRight />}
              {userMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul className={`ml-4 ${userMenuOpen ? "block" : "hidden"}`}>
              <li onClick={handleToggleSidebar}>
                <Link to={"/dashboard/user"}>1. Manage User</Link>
              </li>
            </ul>
          </li>
        )}
        <li>
          <a
            onClick={toggleDealerMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Client Management
            {dealerMenuOpen === false && <FaArrowAltCircleRight />}
            {dealerMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              dealerMenuOpen ? "block" : "hidden"
            }`}
          >
            <li onClick={handleToggleSidebar}>
              <Link to={"/dashboard/dealer"}> Client Open</Link>
            </li>
            <li onClick={handleToggleSidebar}>
              <Link to={"/dashboard/cash-receive"}>Client Collection</Link>
            </li>
            <li onClick={handleToggleSidebar}>
              <Link to={"/dashboard/dealer-due-opening"}>Dealer Due Open</Link>
            </li>
            <li onClick={handleToggleSidebar}>
              <Link to={"/dashboard/dealer-statement"}>Client Statement</Link>
            </li>
            <li onClick={handleToggleSidebar}>
              <Link to={"/dashboard/dealer-summary"}>Client Summary</Link>
            </li>
          </ul>
        </li>
        <li>
          <a
            onClick={toggleSupplierMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Supplier Management
            {supplierMenuOpen === false && <FaArrowAltCircleRight />}
            {supplierMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              supplierMenuOpen ? "block" : "hidden"
            }`}
          >
            <li>
              <Link to={"/dashboard/supplier"}>Supplier Open</Link>
            </li>
            <li>
              <Link to={"/dashboard/cash-payment"}>Supplier Payment</Link>
            </li>
            <li>
              <Link to={"/dashboard/supplier-due-opening"}>
                Supplier Due Open
              </Link>
            </li>
            <li>
              <Link to={"/dashboard/supplier-statement"}>
                Supplier Statement
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <a
            onClick={toggleCategoryMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Product Management
            {categoryMenuOpen === false && <FaArrowAltCircleRight />}
            {categoryMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              categoryMenuOpen ? "block" : "hidden"
            } `}
          >
            <li>
              <Link to="/dashboard/category"> Category</Link>
            </li>
            <li>
              <Link to="/dashboard/sub_category"> Brand</Link>
            </li>
            <li>
              <Link to="/dashboard/product"> Product </Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to="/dashboard/models"> Models</Link>
            </li>
            <li>
              <Link to="/dashboard/opening-balance"> Opening Balance</Link>
            </li>
          </ul>
        </li>
        {/* <li>
          <a
            onClick={toggleLedgerMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Accounts Management
            {ledgerMenuOpen === false && <FaArrowAltCircleRight />}
            {ledgerMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul className={`ml-4 ${ledgerMenuOpen ? "block" : "hidden"}`}>
            {user?.role === "admins" && (
              <li>
                <Link to={"/dashboard/ledger-list"}>1. Ledger List</Link>
              </li>
            )}
            <li>
              <Link to={"/dashboard/account-page"}>2. Account Page</Link>
            </li>
            <li>
              <Link to={"/dashboard/dealer-statement"}>
                3. Dealer Statement
              </Link>
            </li>
            <li>
              <Link to={"/dashboard/supplier-statement"}>
                4. Supplier Statement
              </Link>
            </li>
          </ul>
        </li> */}
        {/* <li>
          <Link to={"/dashboard/manufacture"}>Manufacture Management</Link>
        </li> */}
        {user?.role === "admin" && (
          <li>
            <a
              onClick={togglePurchaseMenu}
              href="#"
              className="flex items-center justify-between"
            >
              Purchase Management
              {purchaseMenuOpen === false && <FaArrowAltCircleRight />}
              {purchaseMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul
              className={`ml-4 list-disc ${
                purchaseMenuOpen ? "block" : "hidden"
              }`}
            >
              <li>
                <Link to={"/dashboard/purchase"}> Product Purchase</Link>
              </li>
            </ul>
          </li>
        )}
        <li>
          <a
            onClick={toggleSalesMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Sales Management
            {salesMenuOpen === false && <FaArrowAltCircleRight />}
            {salesMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              salesMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li>
              <Link to={"/dashboard/rate"}>Sales Rate</Link>
            </li> */}
            <li>
              <Link to={"/dashboard/orders"}>Sales & Invoice</Link>
            </li>
            <li>
              <Link to={"/dashboard/order/product"}> Sales Product List</Link>
            </li>
            {/* <li>
              <Link to={"/dashboard/repeat"}> Sales Rate History</Link>
            </li> */}
          </ul>
        </li>
        <li>
          <a
            onClick={toggleQuotationMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Quotation
            {quotationMenuOpen === false && <FaArrowAltCircleRight />}
            {quotationMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              quotationMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/rate"}>Sales Rate</Link>
            </li> */}
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/quotation"}>Quotation Entry</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/quotation/items"}> Quotation List</Link>
            </li>
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/repeat"}> Sales Rate History</Link>
            </li> */}
          </ul>
        </li>
        <li>
          <a
            onClick={toggleChallanMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Challan
            {challanMenuOpen === false && <FaArrowAltCircleRight />}
            {challanMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              challanMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/rate"}>Sales Rate</Link>
            </li> */}
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/challan"}>Challan Entry</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/challan/list"}>Challan List</Link>
            </li>
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/repeat"}> Sales Rate History</Link>
            </li> */}
          </ul>
        </li>
        {/* {user?.role === "admin" && (
          <li>
            <a
              onClick={toggleTransactionMenu}
              href="#"
              className="flex items-center justify-between"
            >
              Sales Transaction
              {transactionMenuOpen === false && <FaArrowAltCircleRight />}
              {transactionMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul className={`ml-4 ${transactionMenuOpen ? "block" : "hidden"}`}>
              <li>
                <Link to={"/dashboard/transaction"}>1. Transaction</Link>
              </li>
              <li>
                <Link to={"/dashboard/pay"}>2. Pay Due History</Link>
              </li>
              <li>
                <Link to={"/dashboard/dealerDue"}>3. Dealer Dues</Link>
              </li>
            </ul>
          </li>
        )} */}
        {user?.email === "pixel@gmail.com" && (
          <li>
            <a
              onClick={toggleBankMenu}
              href="#"
              className="flex items-center justify-between"
            >
              Bank Transaction
              {bankMenuOpen === false && <FaArrowAltCircleRight />}
              {bankMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul
              className={`ml-4 list-disc ${bankMenuOpen ? "block" : "hidden"}`}
            >
              <li>
                <Link to={"/dashboard/bankinfo"}> Bank Info</Link>
              </li>
              <li>
                <Link to={"/dashboard/bankdeposit"}>Bank Deposit</Link>
              </li>
            </ul>
          </li>
        )}
        <li>
          <a
            onClick={toggleReturnMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Return & Damage
            {returnMenuOpen === false && <FaArrowAltCircleRight />}
            {returnMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              returnMenuOpen ? "block" : "hidden"
            }`}
          >
            <li>
              <Link to={"/dashboard/returnProduct"}> Sales Return</Link>
            </li>
            <li>
              <Link to={"/dashboard/salesReturnList"}>Return Product List</Link>
            </li>
            <li>
              <Link to={"/dashboard/damageProduct"}>Damage Product</Link>
            </li>
          </ul>
        </li>
        <li>
          <Link to={"/dashboard/warehouse"}>Warehouse Management</Link>
        </li>
        <li>
          <a
            onClick={toggleReportMenu}
            href="#"
            className="flex items-center justify-between"
          >
            All Reports
            {reportMenuOpen === false && <FaArrowAltCircleRight />}
            {reportMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              reportMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li>
              <Link to={"/dashboard/report/purchase/daily"}>
                Daily Purchase Report
              </Link>
            </li> */}
            <li>
              <Link to={"/dashboard/report/purchase"}>
                Date-wise Purchase Report
              </Link>
            </li>
            {/* <li>
              <Link to={"/dashboard/report/sales/daily"}>
                Daily Sales Report
              </Link>
            </li> */}
            <li>
              <Link to={"/dashboard/report/sales"}>Date-wise Sales Report</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/transaction/report"}>
                Transaction Report
              </Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/collection/report"}>Collection Report</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/payment/report"}>Payment Report</Link>
            </li>
            <li>
              <Link to={"/dashboard/report/stock"}>Stock Report</Link>
            </li>
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/stock/purchase"}>
                Purchase Stock
              </Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/stock/sales"}>Sales Stock</Link>
            </li> */}
          </ul>
        </li>
      </ul>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default SidebarMobile;
